/*****************************************************************************
 * Open MCT, Copyright (c) 2014-2017, United States Government
 * as represented by the Administrator of the National Aeronautics and Space
 * Administration. All rights reserved.
 *
 * Open MCT is licensed under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 *
 * Open MCT includes source code licensed under additional open source
 * licenses. See the Open Source Licenses file (LICENSES.md) included with
 * this source code distribution or the Licensing information page available
 * at runtime from the About dialog for additional information.
 *****************************************************************************/

define(
    'platform/features/notebook/src/actions/RemoveSnapshot',[],
    function () {

        function RemoveSnapshot(dialogService, context) {
            context = context || {};

            this.domainObject = context.selectedObject || context.domainObject;
            this.dialogService = dialogService;
        }



        RemoveSnapshot.prototype.perform = function ($event, snapshot, embedId, entryId) {

            var domainObject = this.domainObject;
            var errorDialog = this.dialogService.showBlockingMessage({
                severity: "error",
                title: "This action will permanently delete this Snapshot. Do you want to continue?",
                minimized: true, // want the notification to be minimized initially (don't show banner)
                options: [{
                    label: "OK",
                    callback: function () {
                        errorDialog.dismiss();
                        remove();
                    }
                },{
                    label: "Cancel",
                    callback: function () {
                        errorDialog.dismiss();
                    }
                }]
            });

            function remove() {
                domainObject.useCapability('mutation', function (model) {
                    var elementPos = model.entries.map(function (x) {
                        return x.createdOn;
                    }).indexOf(entryId);
                    var entryEmbeds = model.entries[elementPos].embeds;
                    var embedPos = entryEmbeds.map(function (x) {
                        return x.id;
                    }).indexOf(embedId);
                    model.entries[elementPos].embeds[embedPos].snapshot = "";
                });
            }

        };

        return RemoveSnapshot;
    }
);

